
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { AxiosData } from "@/common/http/http";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";

import {
  DeepLoop
} from '@/common/deepLoop/deepLoop'

import { BlueToothListAPI } from "@/common/api/userManage/blueToothList";
import { CommonApi } from "@/common/api/common";

import {
  getCommonList
} from '@/common/config'

// import { excuteDownloadExport2Excel } from "@/common/xlsx";
export const pageApiList = getPageAPIs(BlueToothListAPI);

import {
  shareConfirmOptions,
  // transferUserLevel2ch,
  defaultUserMemberList,
} from "@/common/config";


// 分类:1普通话2方言
// const blueToothCategory2Ch: string[] = ['', '普通话', '方言']

// 状态：1上架，2下架
// const blueToothStatus2Ch: string[] = ['', '上架', '下架']


const defaultForms: any = {
  name: '',
  resource: '',
  // light_pack_id: '',
  // light_pack_url: '',
  // status: 1, // 状态：1上架，2下架
}

const blueToothDialogTitle2ch: any = {
  "new-blue-tooth": "新增蓝牙开关",
  "edit-blue-tooth": "编辑蓝牙开关",
};

@Component({
  filters: {
    // showBlueToothCategoryName(category: number) {
    //   return blueToothCategory2Ch[category] || ''
    // },

    // showBlueToothStatusName(status: number) {
    //   return blueToothStatus2Ch[status] || ''
    // }
  }
})
export default class BlueTooth extends Vue {
  private utilInstance: any;
  private blueToothListApi: any;

  private commonApi: any;

  private deepLoopUtil: any = {};


  constructor() {
    super();
    this.blueToothListApi = new BlueToothListAPI();

    this.commonApi = new CommonApi();

    this.deepLoopUtil = new DeepLoop();

    this.utilInstance = new Util();

    this.forms = {
      ...DeepLoop.deepClone(defaultForms)
    }

    // 封禁时间列表
    // this.all_forbidden_time_list = Util.getFoibiddenTimeList();
  }

  private firstLoading: boolean = true;

  // private blueToothCategoryList: any[] = [
  //   ...getCommonList(blueToothCategory2Ch, 1)
  // ]

  private form: any = {
    // name: "", // 名称
  };

  private get deviceId() {
    const route = this.$route

    const {
      query = {}
    } = route || {}

    const {
      id = ''
    } = query || {}

    return id
  }

  private activated(): void {
    this.getTable();
  }
  private getTable(): void {
    this.blueToothListApi.getBlueToothTableList(
      this.getBlueToothTableListParams(),
      (res: any) => {
        console.log(res, "res");
        // this.tableData = res.data;
        const { data } = res;

        const { list, count, page, prepage } = data || {};

        const newTableList = Array.isArray(list)
          ? list.map(this.handleTableData)
          : [];

        this.$set(this.tablePage, "totalCount", count);
        this.$set(this.tablePage, "pageNo", page);
        this.$set(this.tablePage, "pageSize", prepage);

        this.tableData = newTableList;

        this.firstLoading = false;
      },
      () => {
        this.firstLoading = false;
      }
    );
  }

  private getBlueToothTableListParams(mode = "all") {
    // mode 可选的值 all  noPageOption exportExcel
    const form = this.form;

    const tablePage = this.tablePage;

    const firstLoading = this.firstLoading;

    const {
      // userName, // 用户昵称
      // name, // 名称
      // userLevel, // 会员等级
      // invite_code, // 邀请码
      // time, // 时间选择
    } = form || {};

    const { pageNo, pageSize } = tablePage || {};

    const outerParams: any = {
      device_id: this.deviceId
    };

    // if (name) {
    //   outerParams.name = name;
    // }
    // if (Array.isArray(time) && time.length === 2) {
    //   const [startDate, endDate] = time;

    //   const startTime = Util.dateTimeUtilnohms(startDate);
    //   const endTime = Util.dateTimeUtilnohms(endDate);

    //   outerParams.created_start_time = startTime;

    //   outerParams.created_end_time = endTime;
    // }

    // if (
    //   mode == "exportExcel" &&
    //   !(outerParams.created_start_time && outerParams.created_end_time)
    // ) {
    //   this.$message.error("请选择时段导出数据");
    //   return null;
    // }

    if (mode === "all") {
      outerParams.page = pageNo;

      outerParams.limit = pageSize;

      outerParams.__isUnique = !firstLoading;
    }

    console.log(outerParams, "outerParams");

    return outerParams;
  }

  // private imagePicUploading: boolean = false
  // private handleUploadLeagueImagePic(file: any, fileList: any[]) {
  //   console.log(file, fileList, "file", "fileList");

  //   this.imagePicUploading = true;
  //   this.commonApi.getOss(
  //     file instanceof File ? file : file.raw,
  //     (res: any) => {
  //       console.log(res, "res 图片上传成功");

  //       const { data } = res;

  //       const { data: callbackData } = data;

  //       const { item: uploadImgObj } = callbackData || {};

  //       const { id, url } = uploadImgObj;

  //       this.$set(this.forms, "cover_pic_id", id);
  //       this.$set(this.forms, "cover_pic_url", url);

  //       this.imagePicUploading = false;
  //     },
  //     () => {
  //       this.$message.error("图片上传失败");

  //       this.imagePicUploading = false;
  //     }
  //   );
  // }

  // private upFileloading: boolean = false

  // private upfileList: any[] = []

  // private handleCustomFileUploadFile(file: any) {
  //   this.upFileloading = true;
  //   this.commonApi.getOssLimitIntNameFile(
  //     file instanceof File ? file : file.raw,
  //     (res: any) => {
  //       console.log(res, "res 文件上传成功");

  //       const { data } = res;

  //       const { data: uploadFileObj } = data || {};

  //       const { item: uploadFile } = uploadFileObj || {};

  //       const { id, url } = uploadFile || {};

  //       this.$set(this.forms, 'light_pack_id', id)
  //       this.$set(this.forms, 'light_pack_url', url)

  //       this.upfileList.push({
  //         id,
  //         url
  //       })

  //       console.log(this.forms, 'forms')

  //       this.upFileloading = false;
  //     },
  //     (err: any) => {
  //       const {
  //         errMsg = ''
  //       } = err || {}

  //       this.$message.error(errMsg || "文件上传失败");

  //       this.upFileloading = false;
  //     },
  //   );
  // }

  // private onFileRemove(file: any) {
  //   const upfileList = this.upfileList

  //   const existFileIndex = upfileList.findIndex((eachFile) => eachFile.id == file.id)

  //   if (existFileIndex > -1) {
  //     this.upfileList.splice(existFileIndex, 1)

  //     this.$set(this.forms, 'light_pack_id', '')
  //     this.$set(this.forms, 'light_pack_url', '')
  //   }
  // }

  // 后台返回的字段 转化为前端定义的字段
  private handleTableData(data: any): any {
    const {} = data;

    const newData = {
      ...data,
    };

    return newData;
  }

  // 删除蓝牙开关设备
  private onDeleteBlueTooth(blueToothItem: any): void {
    console.log(blueToothItem, "blueToothItem");

    const { id } = blueToothItem || {};

   this.$confirm("确认删除该蓝牙开关吗？", "", {
      ...shareConfirmOptions,
    }).then(() => {
      this.blueToothListApi.deleteBlueTooth(
          {
            id,
          },
          () => {
            this.$message.success("删除成功");
            this.getTable();
          }
      );
    });
  }


  // 蓝牙开关管理
  private changeBlueToothLoading: boolean = false

  private addOrUpdateBlueToothManageTitle: string = "蓝牙开关";

  private blueToothDialogMode: string = "";

  private currentBlueToothManageItem: any = null;

  private dialogFormVisible: boolean = false

  private forms: any = {}
  private onWakeBlueToothDialog(mode: string) {
    this.blueToothDialogMode = mode;
    this.addOrUpdateBlueToothManageTitle =
      blueToothDialogTitle2ch[mode] || "蓝牙开关";

    this.initBlueToothManageForm(mode);

    this.dialogFormVisible = true;
  }

   private async initBlueToothManageForm(mode: string) {
    const forms: any = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    // this.upfileList = []


    if (mode == "edit-blue-tooth") {
      const currentBlueToothManageItem = this.currentBlueToothManageItem;

      const {
        id,
        name = '',
        resource = '',
      } = currentBlueToothManageItem || {};

      Object.assign(forms, {
        name,
        resource,
      });


      // this.upfileList = [{
      //   id: light_pack_id,
      //   url: light_pack_oss_url
      // }]


      forms.id = id;
    }

    console.log(forms, "forms");

    this.forms = forms;
  }

  private onWakeEditBlueToothManageDialog(blueToothItem: any) {
    this.currentBlueToothManageItem = blueToothItem;

    this.onWakeBlueToothDialog("edit-blue-tooth");
  }

  private getBlueToothParams(mode: string) {
    const forms = this.forms

    const showErrorMessage = (msg: string) => {
      if (!!msg) {
        this.$message.error(msg);
      }
    };

    const params: any = {
      device_id: this.deviceId
    }

    const {
      id,
      // light_pack_id,
    } = forms

    const keys = ["name", "resource"];

    const key2EndKey: any = {
      name: "name",
      resource: "resource",
   
    };

    const key2ErrMsg: any = {
      name: "设备名称不能为空",
      resource: "mac地址不能为空",

    };

    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];

      if (forms[key]) {
        const errMsg = key2ErrMsg[`${key}_${forms[key]}`];
        if (errMsg) {
          showErrorMessage(errMsg);

          return false;
        }
        params[key2EndKey[key] || key] = forms[key];
      } else {
        showErrorMessage(key2ErrMsg[key]);

        return false;
      }
    }

    
    if (mode == "edit-blue-tooth") {
      params.id = id;
    }

    

    return params
  }

  private onConfirmBlueTooth() {
    const blueToothDialogMode = this.blueToothDialogMode;

    const params = this.getBlueToothParams(blueToothDialogMode)

    if (typeof params != 'object') return

    this.changeBlueToothLoading = true
    switch (blueToothDialogMode) {
      case "new-blue-tooth":
        this.blueToothListApi.addBlueTooth(
          params,
          () => {
            this.getTable();
            this.dialogFormVisible = false;
            this.changeBlueToothLoading = false;
          },
          () => {
            this.changeBlueToothLoading = false;
          }
        );
        break;
      case "edit-blue-tooth":
        this.blueToothListApi.editBlueTooth(
          params,
          () => {
            this.getTable();
            this.dialogFormVisible = false;
            this.changeBlueToothLoading = false;
          },
          () => {
            this.changeBlueToothLoading = false;
          }
        );
        break;
    }

   
  }
 

  /** 导出excel */
  // private downloadExcelLoading: boolean = false;

  // // 用户字段名 文案对应关系
  // private userExcelList2ch: any = {
  //   id: "用户ID",
  //   user_name: "用户昵称",
  //   phone: "用户手机号",
  //   gender_name: "性别",
  //   invite_code: "邀请码",
  //   birthday: "生日",
  //   user_level_name: "会员等级",
  //   created_at: "注册时间",
  //   account_status_name: "账户状态",
  // };
  // // 用户Excel 表头的先后顺序
  // private userExcelSortList: string[] = [
  //   "id",
  //   "user_name",
  //   "phone",
  //   "gender_name",
  //   "invite_code",
  //   "birthday",
  //   "user_level_name",
  //   "created_at",
  //   "account_status_name",
  // ];

  // // 点击导出excel 表格
  // private handleDownloadExcel() {
  //   const params = this.getBlueToothTableListParams("exportExcel");

  //   if (params === null) {
  //     return false;
  //   }

  //   this.downloadExcelLoading = true;
  //   this.blueToothListApi.exportExcelUserList(
  //     params,
  //     (res: any) => {
  //       const { created_start_time, created_end_time } = params || {};

  //       const filename = `用户列表 ${created_start_time}到${created_end_time}.xlsx`;
  //       const { data } = res || {};

  //       const { list: originList } = data || {};

  //       const newList = Array.isArray(originList)
  //         ? originList.map((item) => {
  //             const { gender, type, status } = item;
  //             const newItem = {
  //               ...(item || {}),
  //             };

  //             // if (!forbidTime) {
  //             newItem.gender_name = this.transferGender2ch[gender];

  //             newItem.user_level_name = this.transferUserLevel2ch[type];

  //             newItem.account_status_name =
  //               this.transferUserAccountStatus2ch[status];
  //             // }

  //             return newItem;
  //           })
  //         : [];

  //       if (newList.length > 0) {
  //         const userExcelSortList = this.userExcelSortList;

  //         const userExcelList2ch = this.userExcelList2ch;

  //         const excelJSONData = getExcelJSONDataByList(
  //           newList,
  //           userExcelSortList,
  //           userExcelList2ch
  //         );

  //         excuteDownloadExport2Excel(excelJSONData, filename);
  //       } else {
  //         this.$message.info("选中时段没有可导出的信息");
  //       }

  //       this.downloadExcelLoading = false;
  //     },
  //     () => {
  //       this.downloadExcelLoading = false;
  //     }
  //   );
  // }

  /** end 导出excel */

  private restForm(): void {
    this.form = this.utilInstance.clearObject(this.form);

    this.getTable();
  }

  private search(): void {
    this.tablePage.pageNo = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;

    this.getTable();
  }

  private tableData: any[] = [];

  private tablePage: any = {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
  };

  private handlePageChange(val: any) {
    this.tablePage.pageNo = val.currentPage;
    this.tablePage.pageSize = val.pageSize;

    this.getTable();
  }

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }
}
